'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

require('./modalContent.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ModalContent: {
        displayName: 'ModalContent'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/AddToBasket/default/ModalContentView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
} /**
   * Created by maximus on 01.12.16.
   */


var ModalContent = _wrapComponent('ModalContent')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(ModalContent, _Component);

    function ModalContent(props) {
        (0, _classCallCheck3.default)(this, ModalContent);
        return (0, _possibleConstructorReturn3.default)(this, (ModalContent.__proto__ || (0, _getPrototypeOf2.default)(ModalContent)).call(this, props));
    }

    (0, _createClass3.default)(ModalContent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                product = _props.product,
                count = _props.count,
                lang = _props.lang,
                currency = _props.currency;
            var pictures = this.props.product.pictures;


            var imgSrc = '/assets/images/placeholder.png';
            if (pictures && pictures[0]) {
                if (pictures[0].preview_url) {
                    imgSrc = pictures[0].preview_url;
                } else {
                    if (pictures[0].url) {
                        imgSrc = pictures[0].url;
                    }
                }
            }

            var callbackSuccessBtnText = lang['store.add_to_cart.modal_content.go_to_cart'];
            var callbackCloseBtnText = lang['store.add_to_cart.modal_content.continue_shopping'];

            return _react3.default.createElement(
                'div',
                { className: 'modal_content' },
                _react3.default.createElement(
                    'div',
                    { className: 'content_holder' },
                    _react3.default.createElement(
                        'div',
                        { className: 'product_title' },
                        product.name
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'image_holder' },
                        _react3.default.createElement('img', { className: 'img-responsive', src: imgSrc })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'product_price' },
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: parseFloat(product.price),
                            icon: currency.icon,
                            iconAfterValue: currency.icon_after_value
                        })
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'button_holder' },
                    _react3.default.createElement(
                        'button',
                        { onClick: this.props.callBackSuccess, className: 'le-button' },
                        callbackSuccessBtnText
                    ),
                    _react3.default.createElement(
                        'button',
                        { onClick: this.props.callBackClose, className: 'le-button button_close' },
                        callbackCloseBtnText
                    )
                )
            );
        }
    }]);
    return ModalContent;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp));

exports.default = ModalContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/AddToBasket/default/ModalContentView.jsx
// module id = 1612
// module chunks = 0